import {BASE_AUDIT_API, authorizedFetch, fetchAPI, getHttpErrorMessage} from '@/services/api';

export interface AuditFsWpIssueListItem {
    fsId: number;
    code?: string;
    name?: string;
    scheduleCode?: string;
    wpCode?: string;
    statement?: string;
    wpStatus?: number | null;
    wpIssueRemark?: string | null;
    outstanding?: boolean;
    outstandingRemark?: string | null;
    issueStatus?: number | null;
}

const base = `${BASE_AUDIT_API}/audit-fs-wp-issue`;

export async function listFsWpIssues(companyId: number, annualId: number) {
    return fetchAPI<AuditFsWpIssueListItem[]>(`${base}/list?companyId=${companyId}&annualId=${annualId}`);
}

export async function updateFsWpIssueStatus(params: {
    companyId: number;
    annualId: number;
    fsId: number;
    issueStatus: number;
}) {
    return fetchAPI<boolean>(`${base}/updateIssueStatus`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(params),
    });
}

function tryParseFilenameFromContentDisposition(contentDisposition: string | null): string | undefined {
    if (!contentDisposition) return undefined;
    const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(contentDisposition);
    const raw = match?.[1] || match?.[2];
    if (!raw) return undefined;
    try {
        return decodeURIComponent(raw.replace(/\+/g, '%20'));
    } catch {
        return raw.replace(/\+/g, ' ');
    }
}

export async function exportFsWpIssuesExcel(
    companyId: number,
    annualId: number,
    options?: { outstandingOnly?: boolean },
) {
    const outstandingOnly = options?.outstandingOnly ? 'true' : 'false';
    const path = `${base}/export?companyId=${companyId}&annualId=${annualId}&outstandingOnly=${outstandingOnly}`;

    // Must use authorizedFetch so path is ciphered when payload cipher is on.
    const response = await authorizedFetch(path, {method: 'GET'});
    if (!response.ok) {
        throw new Error(await getHttpErrorMessage(response, 'Export failed'));
    }
    // Gateway crypto errors often return HTTP 200 + JSON Result (e.g. code 4605).
    const ct = (response.headers.get('Content-Type') || '').toLowerCase();
    if (ct.includes('json')) {
        throw new Error(await getHttpErrorMessage(response, 'Export failed'));
    }
    const blob = await response.blob();
    const filename = tryParseFilenameFromContentDisposition(response.headers.get('Content-Disposition'))
        || (options?.outstandingOnly ? 'OUTSTANDING TO CLIENT.xlsx' : 'MARK AS ISSUE.xlsx');
    return {blob, filename};
}
